query RevenueShareReportsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: RevenueShareReportsFilterInput
) {
  revenueShareReports(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      organizationId
      organization {
        id
        title
      }
      contractId
      contract {
        id
        title
        currency
      }
      period
      status
      purchasesCount
      feePercentages
      refundsCount
      disputesCount
      contractPaymentId
      salesAmount {
        value
        currency
        valueUSD
      }
      providerFeeAmount {
        value
        currency
        valueUSD
      }
      feeAmount {
        value
        currency
        valueUSD
      }
      refundsAmount {
        value
        currency
        valueUSD
      }
      disputesAmount {
        value
        currency
        valueUSD
      }
      reportAmount {
        value
        currency
        valueUSD
      }
      reportAmountInContractCurrency {
        value
        currency
        valueUSD
      }
      exchangeRate {
        rate
        date
        source
      }
      corrections {
        description
        creatorId
        createdAt
        amount {
          value
          currency
          valueUSD
        }
      }
    }
    count
  }
}
